import { Button, ButtonProps, IconButton } from "@mui/material";
import { useStylesCss } from "./AppButtons.styles";

const AppIconButtonSecondary: React.FC<ButtonProps> = (props: ButtonProps) => {
  const classes = useStylesCss();
  const myClasses = { ...classes.circleWithoutAnimation, ...classes.circleWithoutAnimationSecondary, ...props.sx };
  const myProps = {
    ...props,
    sx: myClasses,
  };
  return (
    <IconButton variant="contained" {...myProps} color="secondary">
      {props.children}
    </IconButton>
  );
};
export default AppIconButtonSecondary;
